import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { createLogger } from 'helpers/logger';
import { setError, startLoading, stopLoading, setStep } from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authResetPasswordReturn({ actionCode, password }) {
  yield put(startLoading());
  try {
    yield call(window.FIREBASE.confirmPasswordReset, actionCode, password);
    yield put(setStep(STEPS.passwordChangeComplete));
    yield call(window.LOGOUT);
  } catch (error) {
    log.info('Change password errors:', error); // eslint-disable-line
    if (error.code === 'auth/invalid-action-code' || error.code === 'auth/expired-action-code') {
      yield put(setError(ERRORS.passwordResetReturnInvalidActionCode));
    } else {
      yield put(setError(ERRORS.passwordResetReturnGeneric));
    }
  } finally {
    yield put(stopLoading());
  }
}
